"use client";

import Image from "next/image";
import type { Guide } from "@/lib/config/guides/types";

interface GuideNavigationProps {
  newer: Guide | null;
  older: Guide | null;
}

export default function GuideNavigation({
  newer,
  older,
}: GuideNavigationProps) {
  return (
    <section className="border-t border-gray-100">
      <div className="mx-auto grid max-w-5xl grid-cols-1 sm:grid-cols-2">
        {/* Newer post (left) */}
        {newer ? (
          <a
            href={`/en/guide/${newer.slug}`}
            className="group flex items-center gap-4 border-b border-gray-100 px-6 py-8 transition-colors hover:bg-gray-50 sm:border-b-0 sm:border-r"
          >
            {newer.coverImage && (
              <div className="relative hidden h-16 w-16 flex-shrink-0 overflow-hidden rounded-lg sm:block">
                <Image
                  src={newer.coverImage}
                  alt={newer.coverImageAlt}
                  fill
                  className="object-cover"
                />
              </div>
            )}
            <div className="min-w-0">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                Newer post
              </p>
              <p className="mt-1 font-heading text-sm font-bold leading-snug text-brand-dark group-hover:text-brand-primary sm:text-base">
                {newer.title}
              </p>
            </div>
          </a>
        ) : (
          <div className="hidden sm:block" />
        )}

        {/* Older post (right) */}
        {older ? (
          <a
            href={`/en/guide/${older.slug}`}
            className="group flex items-center justify-end gap-4 px-6 py-8 text-right transition-colors hover:bg-gray-50"
          >
            <div className="min-w-0">
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                Older post
              </p>
              <p className="mt-1 font-heading text-sm font-bold leading-snug text-brand-dark group-hover:text-brand-primary sm:text-base">
                {older.title}
              </p>
            </div>
            {older.coverImage && (
              <div className="relative hidden h-16 w-16 flex-shrink-0 overflow-hidden rounded-lg sm:block">
                <Image
                  src={older.coverImage}
                  alt={older.coverImageAlt}
                  fill
                  className="object-cover"
                />
              </div>
            )}
          </a>
        ) : (
          <div className="hidden sm:block" />
        )}
      </div>
    </section>
  );
}
